<loading [visible]="loading() || saving()"></loading>

@if(!loading()){
<app-custom-modal [customTitle]="(id ? 'Editar' : 'Nueva') + ' mesa'" (closeFunction)="closeFormFunction()"
    (acceptFunction)="acceptFormFunction()">
    <form [formGroup]="saveForm" (ngSubmit)="saveEntity()" class="space-y-4">

        <custom-input [autofocus]="true" label="Nombre" type="text" [formControlItem]="saveForm.get('name')">
        </custom-input>

        <div class="grid grid-cols-2 gap-4">
            <custom-input label="Capacidad" type="number" [formControlItem]="saveForm.get('capacity')">
            </custom-input>

            <custom-select label="Estado" [formControlItem]="saveForm.controls['status']" [options]="statuses"
                bindValue="id" bindLabel="name" [isMultiple]="false" placeholder="Selecciona un estado">
            </custom-select>
        </div>

        <div class="grid grid-cols-2 gap-4">
            <custom-input label="Posición X" type="number" [formControlItem]="saveForm.get('position_x')">
            </custom-input>

            <custom-input label="Posición Y" type="number" [formControlItem]="saveForm.get('position_y')">
            </custom-input>
        </div>

    </form>
</app-custom-modal>
}
